<h2 mat-dialog-title>{{confirmTitle}}</h2>
<div mat-dialog-content>
  <span class="multiline">{{confirmMessage}}</span>
</div>
<div mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="onClick(false)">No</button>
  <button mat-flat-button color="primary" (click)="onClick(true)" >Yes</button>
</div>
